module.exports = __webpack_public_path__ + "static/media/gateway.89cad181.svg";